import React from "react";
import { Create, SimpleForm } from "react-admin";

import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";
import { AppSecretForm } from "../Form/Form";


export const AppSecretsCreate = (props) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<AppSecretForm />
		</SimpleForm>
	</Create>
);
